import { IDeaInfo, includes, ISaveRequestOutput } from '..';
import {
  filter as lfilter,
  compose as lcompose,
  find as lfind,
  isUndefined,
  map as lmap,
  compact as lcompact,
} from 'lodash/fp';
import { path, not } from 'rambda';
import { flow } from 'fp-ts/function';
import { IRequestStatus } from '../../admin';

export const excludeStatus = (statusList: string[]) =>
  lfilter<ISaveRequestOutput>(
    lcompose(not, includes(statusList), path('status'))
  );

export const sailpointApproveRequestUrl = (sailpointCaseId: string | null) =>
  `${process.env.REACT_APP_SAILPOINT_APPROVE_URL}`;

export const deaNumNotFound = ({ deaNum }: { deaNum: string }) =>
  flow(lfind<IDeaInfo>({ deaNum }), isUndefined);

export const isRequestCancellable = (a: ISaveRequestOutput | IRequestStatus) =>
  a.status === 'SUBMITTED';

export const isRequestNotCancellable = flow(isRequestCancellable, not);

export const getRequestIds = flow(
  lmap<ISaveRequestOutput | IRequestStatus, number | undefined>(
    path('requestId')
  ),
  lcompact
);
